// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum_Extra from "../Data.Enum.Extra/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FormURLEncoded from "../Data.FormURLEncoded/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Record from "../Record/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Tuple.functorTuple);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(Data_Ord.ordString);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var from = /* #__PURE__ */ Type_Equality.from(Type_Equality.refl);
var alt = /* #__PURE__ */ Control_Alt.alt(Data_Maybe.altMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe);
var guard = /* #__PURE__ */ Control_Alternative.guard(Data_Maybe.alternativeMaybe);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var find = /* #__PURE__ */ Data_Foldable.find(Data_Foldable.foldableArray);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe);
var toParamJSON = function (dictEncode) {
    return Foreign_Generic.encodeJSON(dictEncode);
};
var toParam = function (dict) {
    return dict.toParam;
};
var toParamWrapped = function () {
    return function (dictAsParam) {
        var $167 = toParam(dictAsParam);
        return function ($168) {
            return $167(unwrap($168));
        };
    };
};
var renderURL = function (v) {
    if (Data_Map_Internal.isEmpty(v.params)) {
        return v.path;
    };
    if (Data_Boolean.otherwise) {
        var query = Data_Maybe.fromMaybe("")(Data_FormURLEncoded.encode(Data_FormURLEncoded.fromArray(map(map1(Data_Maybe.Just.create))(toUnfoldable(v.params)))));
        return v.path + ("?" + query);
    };
    throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 49, column 1 - line 49, column 35): " + [ v.constructor.name ]);
};
var recordToParamsNil = {
    recordToParams: function (v) {
        return function (v1) {
            return Data_Map_Internal.empty;
        };
    }
};
var recordToParams = function (dict) {
    return dict.recordToParams;
};
var recordToParamsCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    return function (dictAsParam) {
        var toParam1 = toParam(dictAsParam);
        return function () {
            return function (dictRecordToParams) {
                var recordToParams1 = recordToParams(dictRecordToParams);
                return {
                    recordToParams: function (v) {
                        return function (r) {
                            return insert(reflectSymbol(Type_Proxy["Proxy"].value))(toParam1(get(Type_Proxy["Proxy"].value)(r)))(recordToParams1(Type_Proxy["Proxy"].value)(r));
                        };
                    }
                };
            };
        };
    };
};
var recordToParamsConsMb = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictAsParam) {
        var toParam1 = toParam(dictAsParam);
        return function () {
            return function (dictRecordToParams) {
                var recordToParams1 = recordToParams(dictRecordToParams);
                return {
                    recordToParams: function (v) {
                        return function (r) {
                            var v1 = get(Type_Proxy["Proxy"].value)(r);
                            if (v1 instanceof Data_Maybe.Nothing) {
                                return recordToParams1(Type_Proxy["Proxy"].value)(r);
                            };
                            if (v1 instanceof Data_Maybe.Just) {
                                return insert(reflectSymbol(Type_Proxy["Proxy"].value))(toParam1(v1.value0))(recordToParams1(Type_Proxy["Proxy"].value)(r));
                            };
                            throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 133, column 5 - line 135, column 130): " + [ v1.constructor.name ]);
                        };
                    }
                };
            };
        };
    };
};
var recordFromParamsNil = {
    recordFromParams: function (v) {
        return function (v1) {
            return pure(from({}));
        };
    }
};
var recordFromParams = function (dict) {
    return dict.recordFromParams;
};
var genericToParams = function (dict) {
    return dict.genericToParams;
};
var genericToExpandedURL = function (dict) {
    return dict.genericToExpandedURL;
};
var genericToURL = function (dictGeneric) {
    var from1 = Data_Generic_Rep.from(dictGeneric);
    return function (dictGenericAsURL) {
        var $169 = genericToExpandedURL(dictGenericAsURL);
        return function ($170) {
            return renderURL($169(from1($170)));
        };
    };
};
var genericFromParams = function (dict) {
    return dict.genericFromParams;
};
var genericFromExpandedURL = function (dict) {
    return dict.genericFromExpandedURL;
};
var genericAsURLSum = function (dictGenericAsURL) {
    var genericFromExpandedURL1 = genericFromExpandedURL(dictGenericAsURL);
    var genericToExpandedURL1 = genericToExpandedURL(dictGenericAsURL);
    return function (dictGenericAsURL1) {
        var genericFromExpandedURL2 = genericFromExpandedURL(dictGenericAsURL1);
        var genericToExpandedURL2 = genericToExpandedURL(dictGenericAsURL1);
        return {
            genericFromExpandedURL: function (url) {
                return alt(map2(Data_Generic_Rep.Inl.create)(genericFromExpandedURL1(url)))(map2(Data_Generic_Rep.Inr.create)(genericFromExpandedURL2(url)));
            },
            genericToExpandedURL: function (v) {
                if (v instanceof Data_Generic_Rep.Inl) {
                    return genericToExpandedURL1(v.value0);
                };
                if (v instanceof Data_Generic_Rep.Inr) {
                    return genericToExpandedURL2(v.value0);
                };
                throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 67, column 1 - line 70, column 56): " + [ v.constructor.name ]);
            }
        };
    };
};
var genericAsURLConstructor = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictGenericAsParams) {
        var genericFromParams1 = genericFromParams(dictGenericAsParams);
        var genericToParams1 = genericToParams(dictGenericAsParams);
        return {
            genericFromExpandedURL: function (v) {
                return discard(guard(v.path === reflectSymbol(Type_Proxy["Proxy"].value)))(function () {
                    return map2(Data_Generic_Rep.Constructor)(genericFromParams1(v.params));
                });
            },
            genericToExpandedURL: function (v) {
                return {
                    path: reflectSymbol(Type_Proxy["Proxy"].value),
                    params: genericToParams1(v)
                };
            }
        };
    };
};
var genericAsParamsRecord = function () {
    return function (dictRecordFromParams) {
        var recordFromParams1 = recordFromParams(dictRecordFromParams);
        return function (dictRecordToParams) {
            var recordToParams1 = recordToParams(dictRecordToParams);
            return {
                genericFromParams: function (p) {
                    return map2(Data_Generic_Rep.Argument)(recordFromParams1(Type_Proxy["Proxy"].value)(p));
                },
                genericToParams: function (v) {
                    return recordToParams1(Type_Proxy["Proxy"].value)(v);
                }
            };
        };
    };
};
var genericAsParamsNoArguments = {
    genericFromParams: function (v) {
        return pure(Data_Generic_Rep.NoArguments.value);
    },
    genericToParams: function (v) {
        return Data_Map_Internal.empty;
    }
};
var fromParamJSON = function (dictDecode) {
    var $171 = Foreign_Generic.decodeJSON(dictDecode);
    return function ($172) {
        return Data_Either.hush(Control_Monad_Except.runExcept($171($172)));
    };
};
var fromParam = function (dict) {
    return dict.fromParam;
};
var fromParamWrapped = function () {
    return function (dictAsParam) {
        var fromParam1 = fromParam(dictAsParam);
        return function (p) {
            return map2(wrap)(fromParam1(p));
        };
    };
};
var genericAsParamsSingleArg = function (dictAsParam) {
    var fromParam1 = fromParam(dictAsParam);
    var toParam1 = toParam(dictAsParam);
    return {
        genericFromParams: function (p) {
            return bind(lookup("_")(p))(function (param) {
                return map2(Data_Generic_Rep.Argument)(fromParam1(param));
            });
        },
        genericToParams: function (v) {
            return Data_Map_Internal.singleton("_")(toParam1(v));
        }
    };
};
var genericAsParamsSingleArgMb = function (dictAsParam) {
    var fromParam1 = fromParam(dictAsParam);
    var toParam1 = toParam(dictAsParam);
    return {
        genericFromParams: function (p) {
            var rawValue = lookup("_")(p);
            var finalValue = (function () {
                if (rawValue instanceof Data_Maybe.Just) {
                    return map2(Data_Maybe.Just.create)(fromParam1(rawValue.value0));
                };
                if (rawValue instanceof Data_Maybe.Nothing) {
                    return new Data_Maybe.Just(Data_Maybe.Nothing.value);
                };
                throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 88, column 20 - line 90, column 32): " + [ rawValue.constructor.name ]);
            })();
            return map2(Data_Generic_Rep.Argument)(finalValue);
        },
        genericToParams: function (v) {
            if (v instanceof Data_Maybe.Just) {
                return Data_Map_Internal.singleton("_")(toParam1(v.value0));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Map_Internal.empty;
            };
            throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 84, column 6 - line 93, column 49): " + [ v.constructor.name ]);
        }
    };
};
var recordFromParamsCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var insert1 = Record.insert(dictIsSymbol)()();
    return function (dictAsParam) {
        var fromParam1 = fromParam(dictAsParam);
        return function () {
            return function () {
                return function (dictRecordFromParams) {
                    var recordFromParams1 = recordFromParams(dictRecordFromParams);
                    return {
                        recordFromParams: function (v) {
                            return function (p) {
                                return bind(lookup(reflectSymbol(Type_Proxy["Proxy"].value))(p))(function (mapValue) {
                                    return bind(fromParam1(mapValue))(function (value) {
                                        return bind(recordFromParams1(Type_Proxy["Proxy"].value)(p))(function (rest) {
                                            return pure(insert1(Type_Proxy["Proxy"].value)(value)(rest));
                                        });
                                    });
                                });
                            };
                        }
                    };
                };
            };
        };
    };
};
var recordFromParamsConsMb = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var insert1 = Record.insert(dictIsSymbol)()();
    return function (dictAsParam) {
        var fromParam1 = fromParam(dictAsParam);
        return function () {
            return function () {
                return function (dictRecordFromParams) {
                    var recordFromParams1 = recordFromParams(dictRecordFromParams);
                    return {
                        recordFromParams: function (v) {
                            return function (p) {
                                var rawValue = lookup(reflectSymbol(Type_Proxy["Proxy"].value))(p);
                                var finalValue = (function () {
                                    if (rawValue instanceof Data_Maybe.Just) {
                                        return map2(Data_Maybe.Just.create)(fromParam1(rawValue.value0));
                                    };
                                    if (rawValue instanceof Data_Maybe.Nothing) {
                                        return new Data_Maybe.Just(Data_Maybe.Nothing.value);
                                    };
                                    throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 117, column 20 - line 119, column 32): " + [ rawValue.constructor.name ]);
                                })();
                                return bind(finalValue)(function (value) {
                                    return bind(recordFromParams1(Type_Proxy["Proxy"].value)(p))(function (rest) {
                                        return pure(insert1(Type_Proxy["Proxy"].value)(value)(rest));
                                    });
                                });
                            };
                        }
                    };
                };
            };
        };
    };
};
var expandURL = function (s) {
    var v = Data_Array.uncons(Data_String_Common.split("?")(s));
    if (v instanceof Data_Maybe.Nothing) {
        return {
            path: "",
            params: Data_Map_Internal.empty
        };
    };
    if (v instanceof Data_Maybe.Just) {
        var params = fromFoldable(map(map1(Data_Maybe.fromMaybe("")))(Data_Maybe.maybe(mempty)(Data_FormURLEncoded.toArray)(Data_FormURLEncoded.decode(Data_String_Common.joinWith("?")(v.value0.tail)))));
        return {
            path: v.value0.head,
            params: params
        };
    };
    throw new Error("Failed pattern match at Restaumatic.RouteAsURL (line 41, column 3 - line 47, column 25): " + [ v.constructor.name ]);
};
var genericFromURL = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictGenericAsURL) {
        var $173 = map2(to);
        var $174 = genericFromExpandedURL(dictGenericAsURL);
        return function ($175) {
            return $173($174(expandURL($175)));
        };
    };
};
var enumToParam = function (dictShow) {
    return Data_Show.show(dictShow);
};
var enumFromParam = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return function (dictBounded) {
        var allEnumValues = Data_Enum_Extra.allEnumValues(dictBounded);
        return function (dictEnum) {
            var allEnumValues1 = allEnumValues(dictEnum);
            return function (needle) {
                return find(function (value) {
                    return show(value) === needle;
                })(allEnumValues1);
            };
        };
    };
};
var asParamUUID = {
    fromParam: Data_UUID.fromString,
    toParam: Data_UUID.toString
};
var asParamInt = {
    fromParam: Data_Int.fromString,
    toParam: /* #__PURE__ */ Data_Show.show(Data_Show.showInt)
};
var fromParamWrapped1 = /* #__PURE__ */ fromParamWrapped()(asParamInt);
var toParamWrapped1 = /* #__PURE__ */ toParamWrapped()(asParamInt);
var asParamTripId = {
    fromParam: fromParamWrapped1,
    toParam: toParamWrapped1
};
var asParamDeliveryJobId = {
    fromParam: fromParamWrapped1,
    toParam: toParamWrapped1
};
var asParamDate = {
    fromParam: function (d) {
        return map2(wrap)(DateUtils.parseISODate(d));
    },
    toParam: function ($176) {
        return DateUtils.formatISODate(unwrap($176));
    }
};
var asParamBool = {
    fromParam: function (s) {
        var v = Data_String_Common.toLower(s);
        if (v === "true") {
            return pure(true);
        };
        if (v === "false") {
            return pure(false);
        };
        return Data_Maybe.Nothing.value;
    },
    toParam: /* #__PURE__ */ Data_Show.show(Data_Show.showBoolean)
};
var asParamArray = function (dictAsParam) {
    var fromParam1 = fromParam(dictAsParam);
    return {
        fromParam: function (s) {
            return traverse(fromParam1)(Data_String_Common.split(",")(s));
        },
        toParam: (function () {
            var $177 = Data_String_Common.joinWith(",");
            var $178 = map(toParam(dictAsParam));
            return function ($179) {
                return $177($178($179));
            };
        })()
    };
};
export {
    fromParam,
    genericFromExpandedURL,
    genericFromParams,
    genericToExpandedURL,
    genericToParams,
    recordFromParams,
    recordToParams,
    toParam,
    genericFromURL,
    genericToURL,
    expandURL,
    renderURL,
    fromParamWrapped,
    toParamWrapped,
    fromParamJSON,
    toParamJSON,
    enumToParam,
    enumFromParam,
    genericAsURLConstructor,
    genericAsURLSum,
    genericAsParamsNoArguments,
    genericAsParamsRecord,
    genericAsParamsSingleArgMb,
    genericAsParamsSingleArg,
    recordFromParamsNil,
    recordToParamsNil,
    recordFromParamsConsMb,
    recordFromParamsCons,
    recordToParamsConsMb,
    recordToParamsCons,
    asParamBool,
    asParamInt,
    asParamUUID,
    asParamDate,
    asParamArray,
    asParamDeliveryJobId,
    asParamTripId
};
